'use client'

import { Box, Typography } from '@mui/material'
import type { ReactNode } from 'react'

type StepLabelProps = {
  /** The label as the locale wrote it, with its verb wrapped by `emphasiseVerb`, plus any trailing note. */
  children: ReactNode
}

/** Muted body text for a step row. */
export default function StepLabel({ children }: StepLabelProps) {
  return (
    <Typography variant="body2" component="span" data-testid="step-label" sx={{ color: 'inherit' }}>
      {children}
    </Typography>
  )
}

/**
 * The renderer for the `<verb>` tag in a step-label message: each locale marks the word or phrase that acts as the
 * verb, which shows at a slightly stronger weight.
 */
export function emphasiseVerb(chunks: ReactNode) {
  return (
    <Box component="span" sx={{ fontWeight: 500 }}>
      {chunks}
    </Box>
  )
}
